


















import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { JinroPlayerDocument } from "../../services/datatypes";
import { UserStatusState } from "../../services/user-status-state";
import { firestore } from "@/scripts/firebase";
import { onlineTimeSince } from "@/utils/utils";

@Component
export default class PlayerStatus extends Vue {
  @Prop() readonly player!: JinroPlayerDocument;

  get isGuest(): boolean {
    if (!this.player) {
      return false;
    }

    return this.player.isGuest;
  }

  get hasStatus(): boolean {
    if (!this.player || !this.player.userStatus) {
      return false;
    }
    return true;
  }

  get isOnline(): boolean {
    if (!this.player || !this.player.userStatus) {
      return false;
    }

    return this.player.userStatus.state === UserStatusState.Online;
  }

  get isOffline(): boolean {
    if (!this.player || !this.player.userStatus) {
      return false;
    }

    return this.player.userStatus.state === UserStatusState.Offline;
  }

  get dateFromNow(): string {
    if (!this.player || !this.player.userStatus) {
      return "";
    }
    const time = this.player.userStatus
      .timeLastChanged as firebase.firestore.Timestamp;
    const timeLastChanged = time.toDate();

    return onlineTimeSince(timeLastChanged);
  }
}
